import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { getGuessLikes } from '../../actions/recommend';
import { cleanSearchRecommend } from '../../actions/search';
import SoftCardRank from '../../components/SoftCardRank/SoftCardRank';
import { CONTEXT } from '../../config';
import styles from './GuessLikes.module.less';
import { sortSoftsByLocalSoftInit } from '../../utils/utils';

import recoBg from '../../static/reco_bg.png';

const selectGuessLikes = createSelector(
  state => state.recommend,
  recommend => recommend.guessLike,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(({ logInfo }) => {
  const dispatch = useDispatch();
  const guessLikesData = useSelector(selectGuessLikes);
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);

  const pageSize = 60;
  const showSize = 9;
  const [showApps, setShowApps] = useState([]);

  const handleShowMore = useCallback(() => {
    // 推荐页面banner点击打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Recomore',
        label: '',
        param2: {
          source: `${logInfo.tag}_Guess`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: `${logInfo.tag}_Guess`,
        source_pp: logInfoData.source_p,
      }),
    );
    dispatch(cleanSearchRecommend());
  }, [dispatch]);

  useEffect(() => {
    // dispatch(getGuessLikes({ skip: 0, limit: pageSize }));
  }, []);

  useEffect(() => {
    if (!guessLikesData || !guessLikesData.apps || guessLikesData.limit !== pageSize) {
      dispatch(getGuessLikes({ skip: 0, limit: pageSize }));
    } else {
      const show_Apps = sortSoftsByLocalSoftInit(guessLikesData.apps || [], localSoftsInit);
      setShowApps(show_Apps.slice(0, showSize));
    }
  }, [dispatch, guessLikesData, localSoftsInit]);

  return (
    showApps &&
    showApps.length > 0 && (
      <div className={styles.recommend_GuessLikes}>
        <div className={styles.recommend_header}>
          <div className={styles.recommend_header_title}>猜你喜欢</div>
          <Link
            className={styles.recommend_header_link}
            onClick={() => {
              handleShowMore();
            }}
            to={{ pathname: `${CONTEXT}/guesslikesmore` }}
          >
            更多
          </Link>
        </div>
        <img className={styles.recommend_header_bg} src={recoBg} />
        <div className={styles.soft_cards}>
          {showApps.map((soft, i) => (
            <SoftCardRank
              soft={soft}
              logInfo={{
                source: `${logInfo.tag}_Guess`,
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
              }}
              key={i}
            />
          ))}
        </div>
      </div>
    )
  );
});
